import { render, staticRenderFns } from "./BaseListItem.vue?vue&type=template&id=ddb89574&scoped=true&"
import script from "./BaseListItem.vue?vue&type=script&lang=js&"
export * from "./BaseListItem.vue?vue&type=script&lang=js&"
import style0 from "./BaseListItem.vue?vue&type=style&index=0&id=ddb89574&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddb89574",
  null
  
)

export default component.exports